module.exports = "<simple-link target=\"task.event_emitter\"></simple-link> forgot their password and requested reset.";